<template>
  <AsyncModal
    :show="show"
    header-text="Edit billing address"
    :header-icon="['fas', 'fa-map-marker-alt']"
    :async-function="save"
    confirm-text="Save"
    @close="emit('close')"
    @done="onDone"
  >
    <template #content>
      <div class="tw-mb-8 tw-px-4">
        <AddressForm
          :form="form"
          :errors="errors"
          :supports-vat-id="supportsVatID"
          @updated:form="({ field, value }) => updateFormField(field, value)"
        />
      </div>
    </template>
  </AsyncModal>
</template>

<script lang="ts">
import { useUserStore } from 'gpcore-apikit/store/pinia/user';
import AsyncModal from 'gpcore-uikit/components/new/AsyncModal.vue';
import { defineComponent, inject } from 'vue';
import AddressForm from './address/AddressForm.vue';
import useBillingProfileCountries from './composables/useBillingProfileCountries';
import useBillingProfileFields from './composables/useBillingProfileFields';
import { BillingProfileInject } from './symbols';

export default defineComponent({
  emits: ['close', 'updated'],
  components: {
    AddressForm,
    AsyncModal,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, { emit }) {
    const billingProfile = inject(BillingProfileInject);

    const { countryOptions } = useBillingProfileCountries();
    const { form, errors, supportsVatID, handleSubmit, updateFormField } = useBillingProfileFields({
      billingProfile: billingProfile.value,
    });

    const userStore = useUserStore();
    const submit = handleSubmit(() => {
      if (!supportsVatID.value) {
        form.vatId = '';
      }

      return userStore.updateBillingProfile({
        id: billingProfile.value.id,
        ...form,
        countryCode: form.country.key,
      });
    });
    const onDone = () => {
      emit('updated');
    };

    const save = () => {
      submit();
    };

    return {
      billingProfile,
      form,
      errors,
      supportsVatID,
      updateFormField,
      countryOptions,
      save,
      onDone,
      emit,
    };
  },
});
</script>
